import NavBar from './NavBar';

export default function NotFound() {
	return (
		<div className='flex flex-col min-h-screen bg-gray-50'>
			<NavBar />
			<section className='bg-[#13335A] scale-75 rounded-md w-[90%] sm:w-[70%] md:w-[60%] lg:w-[50%] mt-[130px] mx-auto my-auto'>
				<div className='py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6'>
					<div className='mx-auto max-w-screen-sm text-center'>
						<h1 className='mb-4 text-white text-5xl sm:text-6xl lg:text-7xl tracking-tight font-extrabold text-primary-600'>
							404
						</h1>
						<p className='mb-10 text-2xl sm:text-3xl md:text-4xl tracking-tight font-bold text-slate-100'>
							Página não encontrada
						</p>
						<p className='mb-7 text-sm sm:text-base md:text-lg font-light text-gray-300'>
							A página que você buscou não existe ou se encontra
							em manutenção, retorne à página inicial.
						</p>
						<a
							href='/home'
							className='inline-flex hover:scale-105 transition-transform text-gray-300 bg-primary-600 hover:bg-primary-800 focus:ring-4 outline focus:ring-primary-300 font-medium rounded-lg text-xl px-5 py-2.5 text-center my-4'>
							<span> Voltar para a página inicial</span>
						</a>
					</div>
				</div>
			</section>
		</div>
	);
}
